// extracted by mini-css-extract-plugin
export default {"FullScreenButton":"styles_FullScreenButton__rEiZN","fullScreenArrows":"styles_fullScreenArrows__Wfp8v","active":"styles_active__qd+SY"};